/**
 * 表单检测的mixin
 */
import { Toast } from 'vant'
const formMixins = {
    data(){
        return {

        }
    },
    methods: {
        // 验证表单 不显示
        checkForm(){
            return new Promise((resolve, reject)=>{
                let flag = true
                let name, msg, type, text;
                for(let i=0; i<this.requiredRules.length; i++){
                    name = this.requiredRules[i].name;
                    text = this.requiredRules[i].text;
                    type = this.requiredRules[i].type;
                    // 判断值是否为空
                    if(this.form[name] == '' || this.isEmptyObject(this.form[name])){
                        flag = false;
                        msg = `${text}不能为空`;
                        break;
                    }
                    // 判断数字是否小于零
                    // pNumber 正数 nNumber 负数 zNumber 零
                    if(type && type == 'pNumber' && Number(this.form[name]) <= 0){
                        msg = `${text}不合法`;
                        flag = false;
                        break;
                    }
                }
                if(flag){
                    resolve('ok')
                }else{
                    Toast.fail(msg)
                }
            })
        },
        isEmptyObject(e) {
            var t;
            for (t in e)
                return false;
            return true
        },
        // 密码验证规则
        checkPsw(val){
            let reg = /^(\w){6,20}$/
            return reg.test(val)
        },
        clearForm(){

        }
    }
}
export default formMixins;



// WEBPACK FOOTER //
// ./src/mixins/form.js